<template>
  <slot
    name="prepend"
    v-bind="{ hasQuestions: Boolean(questionsMerged?.length) }"
  />
  <UAccordion
    open-icon="i-fluent-add-24-regular"
    close-icon="i-fluent-subtract-24-regular"
    color="white"
    :ui="{
      default: {
        class: buttonClasses,
        truncate: false,
      },
    }"
    size="xl"
    :items="questionsMerged"
  >
    <template #item="{ item }">
      <div :class="answerClasses" v-html="item.content"></div>
    </template>
  </UAccordion>
</template>

<script lang="ts" setup>
import type { AFaqAccordionQuestion } from '~/components/resources/questions/types'
import { twMerge } from 'tailwind-merge'

const props = withDefaults(
  defineProps<{
    answerAttrs?: Record<string, any>
    buttonAttrs?: Record<string, any>
    fetchDefaultQuestions?: boolean
    limit?: number
    questions?: AFaqAccordionQuestion[]
  }>(),
  {
    fetchDefaultQuestions: true,
    limit: 100,
  },
)

const buttonClasses = computed(() =>
  twMerge(
    'mb-0 sm:text-lg text-base text-left font-semibold',
    props.buttonAttrs?.class,
  ),
)

const answerClasses = computed(() =>
  twMerge(
    'text-black text-[1rem] leading-[1.2rem] font-normal leading-2 *:!text-left px-4 dark:text-white',
    props.answerAttrs?.class,
  ),
)

const { data: questions, error: questionsError } = await useFetch(
  '/api/questions/faq-accordion',
  {
    query: {
      limit: props.limit,
    },
  },
)

assertDefined(questions, questionsError)

const questionsMerged = computed(() => {
  if(props.questions) {
    return formatQuestions(props.questions)
  }

  const propsQuestions = props.questions
    ? formatQuestions(props.questions)
    : []
  const fetchedQuestionsFormatted = props.fetchDefaultQuestions
    ? questions
      ? formatQuestions(questions.value)
      : []
    : []
  return [...propsQuestions, ...fetchedQuestionsFormatted]
})

function formatQuestions(questions: AFaqAccordionQuestion[] | null) {
  if (!questions)
    return []
  return questions.map(item => ({
    content: item.answer,
    label: item.question,
  }))
}
</script>